import React, { Component } from 'react'

export default class Description extends Component {
    render() {
        return (
            <div>
                <section class="home-3 section" id="home" style={{

                }}>
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-6">
                                <div class="home-content text-start">
                                    <div class="title home-heading">
                                        <h1 class="fw-bold"> Nots.art</h1>
                                        <h3 class="fw-bold">Professionally Managed and Secure Staking</h3>
                                        <p className='text-white'>
                                            Stake your cryptocurrency on Starts, Juno Network and more!
                                        </p>
                                        {/* <button class="btn btn-dark rounded">Get Started <i
                            class="mdi mdi-arrow-top-right align-middle"></i></button> */}
                                    </div>
                                    <div class="mt-5 border-bottom"></div>

                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="">

                                    <img src="images/cards.png" alt="img" class="img-fluid" />

                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </div>
        )
    }
}
